export class NewUserFormData {
    public id: any;
    public firstName: any;
    public lastName: any;
    public middleName: any;
    public fullName: any;
    public emailAddress: any;
    public phoneNumber: any;
    public phoneNumberExtension: any;
    public phoneNumber2Extension: any;
    public passwordResetTokenCode: any;
    public passwordResetTokenExpires: any;
    public resetPasswordDate: any;
    public phoneNumber2: any;
    public title: any;
    public isActive: boolean;
    public isExternal: boolean;
    public isLocked: boolean;
    public resetPassword: boolean;
    public roles: any[] = [];
    public contactTypes: any[] = [];
    public organizations: any;
    public activeOrgUser: boolean;
    public isExistingUser: boolean;
    public isEPUser: boolean;
    public accountType: string;
}

export class UserEmails {
    public NewEmailAddress: any;
    public ConfirmEmailAddress: any;
    public ExistingUser: boolean;
    public CreateUser: string;
}
